export default class AggregateStatusReporter {
    constructor() {
        this.callbacks = new Set();
    }
    addCallback(callback = () => { }) {
        this.callbacks.add(callback);
        callback(this.currentMessage);
    }
    callback(message) {
        this.currentMessage = message;
        for (const elt of this.callbacks) {
            elt(message);
        }
    }
}
//# sourceMappingURL=AggregateStatusReporter.js.map